import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { GOOGLE_TRANSLATE_API_URL, GOOGLE_TRANSLATE_TOKEN } from 'config';

interface ITranslateResponse {
  trans: string;
  source_language_code: string;
  source_language: string;
  trust_level: number;
}

const baseQuery = fetchBaseQuery({
  baseUrl: GOOGLE_TRANSLATE_API_URL,
  prepareHeaders: (headers) => {
    headers.append('content-type', 'application/x-www-form-urlencoded');
    headers.append('X-RapidAPI-Key', GOOGLE_TRANSLATE_TOKEN);
    headers.append('X-RapidAPI-Host', 'google-translate113.p.rapidapi.com');

    return headers;
  },
});

const googleTranslateApi = createApi({
  baseQuery: baseQuery,
  reducerPath: 'googleTranslateApi',
  endpoints: () => ({}),
});

export const translateApi = googleTranslateApi.injectEndpoints({
  endpoints: (build) => ({
    translate: build.mutation<ITranslateResponse, string>({
      query: (text) => ({
        url: '/',
        method: 'POST',
        body: new URLSearchParams({ from: 'auto', to: 'ru', text }),
      }),
    }),
  }),
});

export const { useTranslateMutation } = translateApi;
